import { Component, Input, SimpleChanges } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { Subscription } from 'rxjs';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { PrecisionType } from 'src/app/shared/interfaces/chart.model';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';

Chart.register(...registerables);

@Component({
  selector: 'app-warehouse-space-chart',
  templateUrl: './warehouse-space-chart.component.html',
  styleUrls: ['./warehouse-space-chart.component.scss'],
})
export class WarehouseSpaceChartComponent {
  @Input() spaceData: any;
  @Input() showTimeFrameModeToggle = true;
  public chartObj;

  public dataExistsWithData: boolean = true;

  private yearRange = {
    startYear: undefined,
    endYear: undefined,
  };
  public timeFrameMode: TimeFrameMode;
  public chartParams = [];
  public chartData = {
    year: {},
    quarter: {},
  };

  private config;
  private subs = new Subscription();

  constructor(
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
  ) {
    this.config = {
      DC: {
        name: 'DC',
        type: 'bar',
        label: 'DCs Inventory',
        color: '#747480',
        stacked: true,
        stack: '0',
        legend: { isTop: true, isRight: false },
        precision: PrecisionType.NONE,
        dataLabel: { color: '#2E2E38 ', border: '#2E2E38 ', bg: '#EAEAF2' },
      },
      Branch: {
        name: 'Branch',
        type: 'bar',
        label: 'Branches Inventory',
        color: '#C4C4CD',
        stacked: true,
        stack: '0',
        precision: PrecisionType.NONE,
        legend: { isTop: true, isRight: false },
        titleY: "Pallet Positions ('000)",
        dataLabel: { color: '#2E2E38 ', border: '#2E2E38 ', bg: '#EAEAF2' },
      },
      DC_space: {
        name: 'DC_space',
        type: 'bar',
        label: 'DCs Pallet Positions',
        color: '#FBCC79',
        stacked: true,
        stack: '1',
        precision: PrecisionType.NONE,
        dataLabel: { color: '#8E7A57', border: '#8E7A57', bg: '#FCF8EE' },
      },
      Branch_space: {
        name: 'Branch_space',
        type: 'bar',
        label: 'Branches Pallet Positions',
        color: '#FDEBCB',
        stacked: true,
        stack: '1',
        precision: PrecisionType.NONE,
        dataLabel: { color: '#8E7A57', border: '#8E7A57', bg: '#FCF8EE' },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.timeFrameMode) {
      this.prepareChart();
    }
  }

  ngOnInit(): void {
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((filter) => {
        if (filter) {
          this.yearRange.startYear = filter.start_year;
          this.yearRange.endYear = filter.end_year;
        }
      }),
    );
    this.subs.add(
      this.mondelezDataService.timeFrameMode.subscribe((value) => {
        this.timeFrameMode = value;
        this.prepareChart();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private prepareChart() {
    this.chartParams = [];

    Object.keys(this.config)
      .filter((ele) => Object.keys(this.spaceData['requirement']['year']).includes(ele.split('_')[0]))
      .forEach((el) => {
        this.chartParams.push(this.config[el]);
      });

    this.chartData[this.timeFrameMode]['DC'] = this.calculateVals('requirement', 'DC');
    this.chartData[this.timeFrameMode]['Branch'] = this.calculateVals('requirement', 'Branch');
    this.chartData[this.timeFrameMode]['DC_space'] = this.calculateVals('space', 'DC');
    this.chartData[this.timeFrameMode]['Branch_space'] = this.calculateVals('space', 'Branch');
  }

  private calculateVals(type, graph) {
    if (!Object.keys(this.spaceData[type][this.timeFrameMode]).includes('DC')) {
      this.dataExistsWithData = true;
    } else {
      this.dataExistsWithData = false;
    }
    if (this.spaceData != undefined && this.spaceData[type][this.timeFrameMode][graph]) {
      return this.spaceData[type][this.timeFrameMode][graph].map((el) => this.formatNumbers(el));
    } else {
      return [];
    }
  }

  private formatNumbers(amt: number) {
    if (!amt) return 0;
    let thousands = amt / 1000;
    return parseFloat(thousands.toFixed(1));
  }

  onTimeFrameChange(value: TimeFrameMode) {
    this.mondelezDataService.updateTimeFrameMode(value);
  }
}
